module.exports = __webpack_public_path__ + "static/media/oman.23317d90.png";